import { render, staticRenderFns } from "./MarketInsight.vue?vue&type=template&id=7034fbbd&"
import script from "./MarketInsight.vue?vue&type=script&lang=js&"
export * from "./MarketInsight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports